import apiClient from './apiClient';

const userService = {
  // Search users by email, username or id (authenticated) - exact match for employee addition
  searchUsers: async (query) => {
    const response = await apiClient.get('/users/find', {
      params: { q: query }
    });
    return response.data;
  },

  // Get all users (admin)
  getAll: async (params = {}) => {
    const response = await apiClient.get('/users', { params });
    return response.data;
  },

  // Get user by id
  getById: async (id) => {
    const response = await apiClient.get(`/users/${id}`);
    return response.data;
  },

  create: async (userData) => {
    const response = await apiClient.post('/users', userData);
    return response.data;
  },

  update: async (id, userData) => {
    const response = await apiClient.put(`/users/${id}`, userData);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/users/${id}`);
    return response.data;
  }
};

export default userService;
